import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, createTransform } from 'redux-persist';

//main
import { apiSlice } from '../api/apiSlice';

const isProduction = process.env.NODE_ENV === 'production';

const versionTransform = createTransform(
  // Transform the state before persistence
  (inboundState, key) => {
    if (key === '_persist' && inboundState) {
      return {
        ...inboundState,
        version: parseFloat(process.env.REACT_APP_REDUX_V) || 1,
        rehydrated: true,
      };
    }
    return inboundState;
  },
  // No change needed for rehydration
  (outboundState, key) => outboundState
);

const persistConfig = {
  key: 'root',
  storage,
  migrate: (state) => {
    let savedVersion = state?._persist?.version || 0;
    const newVersion = parseFloat(process.env.REACT_APP_REDUX_V);

    // Define migration strategies here
    if (savedVersion !== newVersion) {
      console.log('Version update required.');
      // return Promise.resolve(undefined); // This resets the state
      return Promise.resolve({
        ...state,
        _persist: {
          version: 1,
          rehydrated: true,
        },
      });
    }
    console.log('Version update is not required.');
    return Promise.resolve(state);
  },
  whitelist: ['settings'],
  transforms: [versionTransform],
};

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(apiSlice.middleware),
  devTools: !isProduction,
});

export const persistor = persistStore(store);
